export const HALL_EVENT_PAYMENT_METHOD_OPTIONS = [
  { value: 'online', label: 'ONLINE' },
  { value: 'cash', label: 'CASH' },
  { value: 'card', label: 'CARD' },
  { value: 'bank_transfer', label: 'BANK TRANSFER' },
  { value: 'company_settlement', label: 'COMPANY SETTLEMENT' },
  { value: 'upi', label: 'UPI' },
  { value: 'credit_sale', label: 'CREDIT SALE' },
  { value: 'cheque', label: 'CHEQUE' },
  { value: 'cash_deposit', label: 'CASH DEPOSIT' },
];

export function buildHallEventBookingNotes(form) {
  const lines = [
    form.notes,
    `Event type: ${form.event_type || 'N/A'}`,
    `Booking type: ${form.booking_type || 'hourly'}`,
    `Guests: ${form.guests || 0} total, ${form.adults || 0} adults, ${form.children || 0} children`,
    `Payment type: ${form.payment_type || 'full'}`,
    `Advance: ${form.advance_amount || 0}, Payment mode: ${form.payment_mode || 'N/A'}`,
  ];
  return lines.filter(Boolean).join('\n');
}

export function parseHallEventBookingNotes(rawNotes) {
  const parsed = {
    notes: '',
    event_type: 'wedding',
    booking_type: '',
    adults: '',
    children: '',
    advance_amount: '',
    payment_mode: 'cash',
    payment_type: '',
  };
  const extraLines = [];

  String(rawNotes || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .forEach((line) => {
      const eventTypeMatch = line.match(/^Event type:\s*(.+)$/i);
      if (eventTypeMatch) {
        parsed.event_type = eventTypeMatch[1].trim().toLowerCase() || parsed.event_type;
        return;
      }

      const bookingTypeMatch = line.match(/^Booking type:\s*(.+)$/i);
      if (bookingTypeMatch) {
        const value = bookingTypeMatch[1].trim().toLowerCase();
        parsed.booking_type = value === 'day' || value === 'full_day' || value === 'full day'
          ? 'day'
          : 'hourly';
        return;
      }

      const brideMatch = line.match(/^Bride:\s*(.+)$/i);
      if (brideMatch) {
        return;
      }

      const groomMatch = line.match(/^Groom:\s*(.+)$/i);
      if (groomMatch) {
        return;
      }

      const guestsMatch = line.match(/^Guests:\s*(\d+)\s+total,\s*(\d+)\s+adults,\s*(\d+)\s+children$/i);
      if (guestsMatch) {
        parsed.adults = guestsMatch[2];
        parsed.children = guestsMatch[3];
        return;
      }

      const paymentTypeMatch = line.match(/^Payment type:\s*(.+)$/i);
      if (paymentTypeMatch) {
        parsed.payment_type = paymentTypeMatch[1].trim().toLowerCase();
        return;
      }

      const advanceMatch = line.match(/^Advance:\s*([^,]+),\s*Payment mode:\s*(.+)$/i);
      if (advanceMatch) {
        parsed.advance_amount = advanceMatch[1].trim();
        parsed.payment_mode = advanceMatch[2].trim().toLowerCase() || parsed.payment_mode;
        return;
      }

      extraLines.push(line);
    });

  parsed.notes = extraLines.join('\n');
  return parsed;
}

export function inferHallEventPaymentType(parsedNotes, amount) {
  const explicitType = String(parsedNotes?.payment_type || '').trim().toLowerCase();
  if (['full', 'partial', 'due'].includes(explicitType)) {
    return explicitType;
  }

  const advance = Number(String(parsedNotes?.advance_amount || '0').replace(/,/g, '')) || 0;
  const total = Number(amount || 0) || 0;
  if (total <= 0 && advance <= 0) return 'due';
  if (advance >= total && total > 0) return 'full';
  if (advance > 0) return 'partial';
  return 'due';
}

export function resolveAdvanceAmountForPaymentType(paymentType, amount, currentAdvance = '') {
  const total = Number(amount || 0) || 0;
  if (paymentType === 'full') {
    return total > 0 ? String(total) : '';
  }
  if (paymentType === 'due') {
    return '0';
  }
  const current = Number(currentAdvance || 0) || 0;
  if (current > 0 && current < total) {
    return String(current);
  }
  if (total > 0) {
    return String(Math.max(1, Math.round(total / 2)));
  }
  return currentAdvance || '';
}
